import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zChildEntitiesCellInfo = z.object({
  view: z.literal("ChildEntitiesCellInfo"),
  labelAtts: zUid.array(),
});
export type ZChildEntitiesCellInfo = z.infer<typeof zChildEntitiesCellInfo>;
